/** @file Hierarchy click: selects the row's bone or slot by modifier, then focuses a placeholder. */
import type { Doc } from '@pose2d/format/types';
import { focusStore } from '../../stores/focusStore';
import { updateSelection } from '../../stores/updateSelection';
import { selectModeOf } from '../../tools/select/selectModeOf';
import { hierarchyActions as A } from './hierarchyActions';
import { parseRowId } from './parseRowId';

/** Selection first, then focus (a selection change clears the focus); Shift adds, Ctrl or Cmd toggles, else replaces (W3-36). */
export function selectRow(doc: Doc, rowId: string, modifiers: { ctrl: boolean; shift: boolean }): void {
  const row = parseRowId(rowId);
  updateSelection(A.pick(row), selectModeOf(modifiers));
  const focus = A.focus(doc, row);
  if (focus !== null) focusStore.setState({ focus });
}
